import Phaser from 'phaser';
import { COLORS, DEPTHS, FONTS, GAME_HEIGHT, GAME_WIDTH, TOOLTIP, toHexColor } from '../config/gameConfig';

export class Tooltip {
  private container: Phaser.GameObjects.Container | null = null;

  constructor(private readonly scene: Phaser.Scene) {
    scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.destroy());
    scene.events.once(Phaser.Scenes.Events.DESTROY, () => this.destroy());
  }

  show(text: string, anchorX: number, anchorY: number): void {
    this.hide();

    const root = this.scene.add.container(0, 0);
    root.setDepth(DEPTHS.modal + 1);

    const measureText = this.scene.add.text(0, 0, text, {
      fontFamily: FONTS.ui,
      fontSize: TOOLTIP.fontSize,
      color: toHexColor(TOOLTIP.textColor),
      wordWrap: { width: TOOLTIP.maxWidth - TOOLTIP.paddingX * 2 },
    });
    const w = measureText.width + TOOLTIP.paddingX * 2;
    const h = measureText.height + TOOLTIP.paddingY * 2;

    let x = anchorX - w / 2;
    let y = anchorY + 10;
    let pointerAbove = true;

    if (y + h > GAME_HEIGHT - 10) {
      y = anchorY - h - 10;
      pointerAbove = false;
    }
    x = Phaser.Math.Clamp(x, 6, GAME_WIDTH - w - 6);

    const bg = this.scene.add
      .rectangle(x, y, w, h, TOOLTIP.bgColor, TOOLTIP.bgAlpha)
      .setOrigin(0, 0)
      .setStrokeStyle(1, COLORS.windowBorder);
    root.add(bg);

    measureText.setPosition(x + TOOLTIP.paddingX, y + TOOLTIP.paddingY);
    root.add(measureText);

    // Pointer triangle
    const pointer = this.scene.add.triangle(
      anchorX,
      pointerAbove ? y : y + h,
      0, 0,
      TOOLTIP.pointerHeight, pointerAbove ? -TOOLTIP.pointerHeight : TOOLTIP.pointerHeight,
      -TOOLTIP.pointerHeight, pointerAbove ? -TOOLTIP.pointerHeight : TOOLTIP.pointerHeight,
      TOOLTIP.bgColor,
      TOOLTIP.bgAlpha,
    );
    root.add(pointer);

    this.container = root;
  }

  hide(): void {
    if (this.container) {
      this.container.destroy();
      this.container = null;
    }
  }

  private destroy(): void {
    this.hide();
  }
}
